<template lang="html">
  <div :class="outerContainerClass">
    <label :class="labelClass">
      {{ descriptionText }}
    </label>
    <div :class="valueContainerClass">
      <textarea
        class="slds-textarea"
        ref="inputArea"
        rows="5"
        v-model="localDescription"
        :maxlength="255"
        @change="onDescriptionChanged"
      ></textarea>
    </div>
  </div>
</template>

<script>
  import { mapState } from "vuex";

  export default {
    name: "ElementDescription",
    props: {
      outerContainerClass: {
        type: String,
        default: "crm-fields-container"
      },
      labelClass: {
        type: String,
        default: "query-label query-object"
      },
      valueContainerClass: {
        type: String,
        default: "obj-select"
      },
      elemDescription: {
        type: String
      },
      label: {
        type: String
      },
      focus: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      ...mapState({
        messages: "messages"
      }),
      descriptionText() {
        return this.label || this.getMessageText(this.messages.DESCRIPTION);
      }
    },
    watch: {
      elemDescription: function() {
        this.localDescription = this.elemDescription;
      }
    },
    mounted() {
      this.localDescription = this.elemDescription;
      if (this.focus) {
        this.$refs.inputArea.focus();
      }
    },
    data() {
      return {
        localDescription: ""
      };
    },
    methods: {
      onDescriptionChanged(event) {
        this.$emit("on-element-description-changed", event.target.value);
      }
    }
  };
</script>

<style scoped></style>
